import { mapState, mapMutations } from 'vuex'
import { MODULE_NAME, MUTATIONS } from '@/store/locations/constants'

export default {
  name: 'MapViewportSwitch',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {}
  },
  computed: {
    ...mapState(MODULE_NAME, ['viewportFilter']),
    useViewportFilter () {
      return this.viewportFilter.enabled
    }
  },
  methods: {
    ...mapMutations(MODULE_NAME, [ MUTATIONS.TOGGLE_VIEWPORT_FILTER ]),
    onSwitchChange ({ state }) {
      this[MUTATIONS.TOGGLE_VIEWPORT_FILTER](state)
    }
  }
}
